import { useAppDispatch, useAppSelector } from "@app/store";
import { selectAuth, userSlice } from "@entities/user";
import { useGetMeQuery } from "@entities/user/api";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";


export const AuthProvider = ({ children }: React.PropsWithChildren) => {
    const auth = useAppSelector(selectAuth)
    const isUserLogedIn = Boolean(auth?.accessToken) 
    
    const { data: user, isLoading, isError, isFetching } = useGetMeQuery(undefined, {
        skip: !isUserLogedIn,
        pollingInterval: 60000
    })

    const dispatch = useAppDispatch()
    
    const navigate = useNavigate();
    const location = useLocation();

    const publicPaths = ['/auth', '/login', '/join'];

    useEffect(() => {
        if(publicPaths.includes(location.pathname)) return;

        if(!isUserLogedIn) {
            navigate('/auth', { replace: true });
            return;
        }

        if(isFetching || isLoading) return
        if(isError || !user){
            dispatch(userSlice.actions.logout())
            navigate('/auth', { replace: true })
            return;
        }

        dispatch(userSlice.actions.setUser(user))
    }, [location.pathname, isLoading, isError, isFetching, user, auth])


    return (
        <>
            {children}
        </>
    )
};